var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewCountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17058",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17058",
    transform: "translate(-9960 8694)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15222",
    "data-name": "\\u9577\\u65B9\\u5F62 15222",
    width: 61,
    height: 61,
    transform: "translate(9960 -8694)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(9960.75 -8690.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5074",
    "data-name": "\\u6955\\u5186\\u5F62 5074",
    cx: 12.721,
    cy: 12.721,
    r: 12.721,
    transform: "translate(6.606 2.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24858",
    "data-name": "\\u30D1\\u30B9 24858",
    d: "M37.216,25.971a7.361,7.361,0,0,1-7.365,7.365H15.228a9.887,9.887,0,0,0,3.241-7.365,17.855,17.855,0,0,0-4.339-11.7,12.971,12.971,0,0,1,5.009-1.018h5.356A12.733,12.733,0,0,1,37.216,25.971Z",
    transform: "translate(21.615 18.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24859",
    "data-name": "\\u30D1\\u30B9 24859",
    d: "M22.006,24H16.65A15.417,15.417,0,0,0,1.25,39.4a7.373,7.373,0,0,0,7.365,7.365H30.041A7.373,7.373,0,0,0,37.406,39.4,15.417,15.417,0,0,0,22.006,24Zm31.469-8.7a10.032,10.032,0,0,1-20.033.8A14.833,14.833,0,0,0,34.7,10.312a10.05,10.05,0,0,1,18.774,4.981Z",
    transform: "translate(0 5.034)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCountIcon);
export default __webpack_public_path__ + "static/media/viewCountIcon.ec20c42c0814b724c2f3db38d7681408.svg";
export { ForwardRef as ReactComponent };